import React, { ReactNode } from "react";

import Modal from "./Modal";

/**
 * SOREMO 共通の確認モーダル（削除・退出などの実行前確認）。
 *
 * 全ページで確認モーダルの見た目を統一するためのラッパー:
 *  - キャンセル: 左・primary（青塗り）・autoFocus（Enter で誤実行しない安全側）
 *  - 実行ボタン: 右・tertiary の塗りボタン（soremo-border、ホバーで soremo-light-gray）
 *  - タイトルは原則なし。本文（`message`）だけで「◯◯しますか？」を伝える
 *
 * 個別ページで `Modal` + primary/secondaryAction を直接組んで確認モーダルを
 * 作らず、必ず本コンポーネントを使うこと。
 */
export interface ConfirmModalProps {
  /** 確認メッセージ本文（例: 「◯◯」を削除しますか？）。改行は \n。 */
  message: ReactNode;
  /** 実行ボタンのラベル（例: 「削除」「退出」）。 */
  confirmLabel: string;
  onConfirm: () => void;
  /** キャンセルボタン・× ・オーバーレイクリックのハンドラ。 */
  onCancel: () => void;
  /** 実行中。実行ボタンが loading になり、キャンセルは disabled。 */
  loading?: boolean;
  /** 補足タイトル（原則なし。文脈の説明がどうしても必要な場合のみ）。 */
  title?: ReactNode;
  /** キャンセルボタンのラベル。既定「キャンセル」。 */
  cancelLabel?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  loading = false,
  title,
  cancelLabel = "キャンセル",
}) => {
  return (
    <Modal
      onClose={onCancel}
      title={title}
      description={message}
      primaryAction={{
        label: confirmLabel,
        onClick: onConfirm,
        theme: "tertiary",
        variant: "filled",
        loading,
      }}
      secondaryAction={{
        label: cancelLabel,
        onClick: onCancel,
        theme: "primary",
        variant: "filled",
        autoFocus: true,
        disabled: loading,
      }}
    />
  );
};

export default ConfirmModal;
